export default __webpack_public_path__ + "static/media/C_Sharp.a7ec03d2.svg";